/**
 * Ryan O'Dowd
 * 2024-12-07
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import {
  TouchableOpacity,
  View,
} from 'react-native';
import Icon from '@react-native-vector-icons/material-design-icons';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const Wrapper = (props: WrapperProps) => {
  const styles = hooks.useStyles(getStyles);

  const [_isExpanded, setIsExpanded] = useState(false);

  return (
    <View
      style={[
        styles.container,
        _isExpanded && styles.expandedContainer,
      ]}
    >
      <View
        style={[
          styles.innerContainer,
          _isExpanded && styles.expandedInnerContainer,
        ]}
      >
        <TouchableOpacity
          style={[
            styles.titleWrapper,
            _isExpanded && styles.expandedTitleWrapper,
          ]}
          onPress={() => setIsExpanded((curr) => !curr)}
        >
          <Icon name={props.titleIcon} size={16 * styles.globalScale} color={styles.colors.accent} />
          <Text style={styles.titleLabel}>{props.titleLabel}</Text>
        </TouchableOpacity>
        <View style={styles.optionsWrapper}>
          {_isExpanded && props.children}
        </View>
      </View>
    </View>
  );
};

class WrapperProps {
  children: React.ReactNode;
  titleIcon: any;
  titleLabel: string;
};

export default Wrapper;
